import { useLocation, useNavigate } from "react-router-dom";
import React from 'react';
import AdminLayout from "../component/AdminLayout";

const PostCardDetail = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const postData = location.state?.post;

    //  console.log("postData:::" , postData)


    const formatDate = (dateString: string) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleString('ko-KR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false // 24시간 형식
        }).replace(/\./g, '-').replace(/\s/g, ' ').replace(/- /g, ' ');

    };



    if (!postData) return <div className="p-5 text-center">정보를 찾을 수 없습니다.</div>;

    return (
        <AdminLayout
            pageTitle="엽서 상세 정보"
            breadcrumbs={[
                { label: 'Home', link: '/admin' },
                { label: 'Postcard', link: '/adminPostCard' },
                { label: 'Detail', active: true }
            ]}
        >

            <div className="main-content">
                <div className="row g-4">
                    {/* 왼쪽: 엽서 이미지 미리보기 */}
                    <div className="col-xxl-4 col-xl-5">
                        <div className="card border-0 shadow-sm h-100">
                            <div className="card-body p-4 text-center">
                                <div className="rounded shadow-sm mb-4 overflow-hidden border">

                                    <img
                                        src={`data:image/jpeg;base64,${postData.postCardPhoto}`}
                                        alt="postcard"
                                        className="w-100 h-auto"
                                    />
                                </div>
                                <button className="btn btn-light w-100" onClick={() => navigate(-1)}>뒤로 가기</button>
                            </div>
                        </div>
                    </div>

                    {/* 오른쪽: 상세 정보 */}
                    <div className="col-xxl-8 col-xl-7">
                        <div className="card border-0 shadow-sm">
                            <div className="card-body p-4">
                                <div className="mb-4">
                                    <small className="text-primary fw-bold">Postcard Title</small>
                                    <h3 className="fw-bold text-dark">{postData.postTitle}</h3>
                                </div>
                                <hr />
                                <div className="row g-4 mb-4">
                                    <div className="col-md-6">
                                        <label className="text-muted d-block fs-12">작가명</label>
                                        <span className="fw-bold">{postData.authorName}</span>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="text-muted d-block fs-12">등록 일시</label>
                                        <span className="fw-bold">{formatDate(postData.createdAt)}</span>
                                    </div>
                                </div>
                                <div className="mb-4">
                                    <label className="text-muted d-block fs-12">엽서 설명</label>
                                    <div className="bg-light p-3 rounded text-dark lh-base">
                                        {postData.postCardDescription || "설명이 없습니다."}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AdminLayout>
    );
};

export default PostCardDetail;